import { get, post, getJson} from '@/utils/datacom';
import { apiUrlApp, jsonUrl, resourceUrl } from '@/utils/env';
import {options} from "vue-resource/src/util";

export const error = (option) => post("api/Log/Error", option); //提交接口异常
export const bannerJSON = (option) => getJson(resourceUrl+'aliapp/bannerNew.json', option); //获取banner图JSON
export const getCurrentMemberInfo = (option) => get("api/user/GetCurrentMemberInfo", option); //获取用户信息
export const getConsumerCoupons = (option) => get("api/Offer/GetConsumerOwnCoupons", option); //获取用户优惠券
// export const getConsumerCoupons = (option) => get("api/Offer/GetConsumerOwnCoupons", option); //获取用户优惠券
export const getActivityPlatformOffers = (option) =>get('api/offer/GetActivityPlatformOffers', option); //获取领券中心优惠券
export const getActivityOffers = (option) => get('api/Offer/GetActivityOffers', option); //获取领券中心优惠券
export const getCouponList = (option) => get('api/Offer/GetActivityPlatformOffers', option);//获取城市优惠券
export const drawFitableCoupon = (option) => get("api/Offer/DrawCoupon",option);  //领取优惠券

export const DrawCoupon = (option) =>get('api/Offer/DrawCoupon', option); //领取优惠券详情
export const luckDrawInit = (option) => get('api/offer/LuckDrawInit', option); //获取抽奖活动信息
export const getLotteryCount = (option) =>get('api/offer/GetLotteryCount', option); //获得当前抽奖次数
export const addLotteryCount = (option) =>get('api/offer/AddLotteryCount',option); //增加抽奖次数
export const getOfferAssistCount = (option) => get("api/Offer/GetOfferAssistCount", option); //获取助力人数接口?offerId=1&beAssistUserId=1
export const luckDraw = (option) =>get('api/offer/LuckDraw',option); //开始抽奖
export const getProductListOffer = (option) =>get('api/car/GetProductListOffer', option); //获取门店置顶活动
export const searchAddress = (option) => get("api/shop/SearchAddress", option); //搜索地址查询附近位置
export const getCity = (option) => get("api/shop/GetShopCitys", option); //初始化城市列表

export const getAddspaces = (option) => get("api/Offer/GetAdSpaces", option); //获取广告位
export const getProductList = (option) => get("api/Car/GetProductList", option); //获取广告位详情

export const apply = (option) => post("api/car/Apply", option); //提交车辆信息
export const getSummerPomotionData = (option) => getJson(resourceUrl + "aliapp/summerPomotion_data.json", option); //提交车辆信息
